import classnames from "classnames";
import jsPDF from "jspdf";
import React, { useContext } from "react";
import splash from "../../assets/img/splash.svg";
import "../../assets/styles/Palette.scss";
import { pallete } from "../../globals";
import { PersonalDataType, RefType } from "../../types";
import { StoreContext } from "../context/Store";
import useModal from "../hooks/useModal";
import Button from "../parts/Button";
import Modal from "../parts/Modal";
import Text from "../parts/Text";
import { formValidation } from "../utils";
import { validation } from "./PersonalData";

export interface CvReadyProps {
  paletteModal: boolean;
  togglePaletteModal(): void;
  printRef?: RefType;
}

export interface CvReadyState {}

export const CvReady = React.forwardRef<HTMLDivElement, CvReadyProps>(
  (props, ref) => {
    const store = useContext(StoreContext);
    const { paletteModal, togglePaletteModal } = props;
    const { palette, setPalette } = store;

    const [doneModal, toggleDoneModal] = useModal();

    const print = () => {
      if (props.printRef && props.printRef.current) {
        const doc = new jsPDF();
        doc.html(props.printRef.current, {
          pagebreak: {
            mode: "css",
          },
          callback: function (doc) {
            try {
              doc.save();
              toggleDoneModal();
            } catch (error) {
              console.log(error);
            }
          },
        });
      }
    };

    const pdfDisabled = !formValidation<PersonalDataType>(
      validation,
      store.personalData
    );
    return (
      <section id="cvready" className="mb-5">
        <Modal open={paletteModal} overlay toggle={togglePaletteModal}>
          <Text tag="h4" color="blue" classes="mb-4">
            Wybierz paletę kolorów dla Twojego CV
          </Text>
          <div className="palette-wrapper">
            <Text tag="p">Wybierz</Text>

            {pallete.map((colors, i) => (
              <div
                className="select-block-element justify-content-between"
                key={i}
                onClick={() => setPalette(i)}
              >
                <div className="d-flex align-items-center">
                  <div
                    className={classnames("mark", { active: palette === i })}
                  ></div>
                  <span>{`PALETA ${i + 1}`}</span>
                </div>
                <div className="palette">
                  <div
                    className="mark color"
                    style={{ backgroundColor: colors[0] }}
                  ></div>
                  <div
                    className="mark color"
                    style={{ backgroundColor: colors[1] }}
                  ></div>
                </div>
              </div>
            ))}
          </div>
        </Modal>
        <Modal open={doneModal} overlay toggle={toggleDoneModal}>
          <div className="done-modal">
            <div className="d-flex flex-column align-items-center">
              <img src={splash} alt="splash" className="mb-4" />
              <Text tag="h2" color="pink" classes="mb-4">
                Gratulacje!
              </Text>
              <Text tag="h4" classes="text-center mb-4">
                Z takim CV możesz śmiało <br />
                szukać pracy
              </Text>
            </div>
          </div>
        </Modal>
        <Text tag="h2" color="pink" classes="mb-5">
          Twoje CV gotowe!
        </Text>
        <Text tag="p" classes="mb-5">
          Sprawdź uważnie, czy wszystko się zgadza. Jeśli coś wymaga korekty,
          popraw to edytując szablon, zapisz i możesz ubiegać się o pracę.
          Trzymamy za Ciebie kciuki.
        </Text>
        <div className="row justify-content-end">
          <div className="col-auto">
            <Button
              onClick={togglePaletteModal}
              classes="smaller-text pink-border mb-2"
            >
              edytuj szablon
            </Button>
          </div>
          <div className="col-auto">
            <Button
              onClick={print}
              disabled={pdfDisabled}
              classes="pink smaller-text mb-2"
            >
              zapisz
            </Button>
          </div>
          <div className="col-auto">
            <Button
              onClick={print}
              disabled={pdfDisabled}
              classes="blue smaller-text mb-2"
            >
              drukuj
            </Button>
          </div>
        </div>
      </section>
    );
  }
);

export default CvReady;
